import { Fragment } from "react/jsx-runtime";
import { Stack, Typography } from "@mui/material";
import { MttrSla } from "~/lib/arrow";

export const MTTRDate = ({
  mttr,
  color,
}: {
  mttr: MttrSla["mttr"];
  color: string;
}) => {
  const noMttrSet = mttr.days === 0 && mttr.hours === 0 && mttr.minutes === 0;

  // intake the hours, days and minutes and round it to the nearest day (up or down depending on the decimal)
  const roundedDays = Math.round(
    mttr.days + mttr.hours / 24 + mttr.minutes / 1440,
  );

  return (
    <Stack
      direction="row"
      alignItems="baseline"
      sx={{
        "& > p": { fontWeight: 700 },
        "& .character": { fontSize: 12, color },
        "& .character:not(:last-child)": {
          marginRight: 0.5,
        },
        "& .number": {
          fontSize: 16,
          color,
        },
        "& .no-mttr": {
          fontSize: 12,
          color: "text.secondary",
        },
      }}
    >
      {noMttrSet ? (
        <Typography className="no-mttr" sx={{ color: "text.secondary" }}>
          NO MTTR YET
        </Typography>
      ) : (
        <Fragment>
          <Typography className="character">MTTR</Typography>
          <Typography className="number">{roundedDays}</Typography>
          <Typography className="character">d</Typography>
        </Fragment>
      )}
    </Stack>
  );
};
